import React from 'react';
import InquiryDetailModal from './components/InquiryDetailModal';
import DeleteConfirmModal from '../common/DeleteConfirmModal';
import Toast from '../common/Toast';

/**
 * InquiryStatusPage 하단에 위치하는 모달 및 토스트들을 그룹화한 컴포넌트.
 */
const InquiryStatusModals = ({
    selectedInquiry,
    onCloseDetail,
    deleteTargetId,
    onCloseDelete,
    onConfirmDelete,
    toastState,
    onCloseToast
}) => {
    return (
        <>
            {/* 질의 상세 모달 */}
            <InquiryDetailModal
                inquiry={selectedInquiry}
                onClose={onCloseDetail}
            />

            {/* 삭제 확인 공통 모달 */}
            <DeleteConfirmModal
                isOpen={!!deleteTargetId}
                onClose={onCloseDelete}
                onConfirm={onConfirmDelete}
            />

            {/* 전역 토스트 알림 */}
            <Toast
                message={toastState.message}
                type={toastState.type}
                onClose={onCloseToast}
            />
        </>
    );
};

export default InquiryStatusModals;
